import * as index_js from './index.js'

export default [index_js]
